export default __webpack_public_path__ + "static/media/mysql.aa790b3c.png";